import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _pick from "lodash/pick";
import _omit from "lodash/omit";
import _groupBy from "lodash/groupBy";
import _debounce from "lodash/debounce";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import dateFormat from "dateformat";
import { useCallback, useContext, useEffect, useMemo, useReducer, useState } from "react";
import useMounted from "../../util/hooks/useMounted";
import { SCHEDULED, LOADING, LOADED, Context, reducer, api as baseApi } from "./Context";
import { POLYMORPH, ACTIONS, toQuery, fromQuery, cid } from "./common";
/**
 * Decorates the base reducer with API calls
 */
export var useComments = function useComments(user, api) {
  // Use a context if it exists. The conditional here works because the existence of
  // a context only changes when mounting/unmounting, which also resets hooks
  var context = useContext(Context);
  if (context) {
    return context;
  }
  api = api || baseApi;

  // Create a new state with reducer otherwise
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    config = _useState2[0],
    setConfig = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    count = _useState6[0],
    setCount = _useState6[1];
  var _useReducer = useReducer(reducer, []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    comments = _useReducer2[0],
    baseReduce = _useReducer2[1];
  var reduce = useMounted(baseReduce);

  // Load scheduled comments
  var load = useCallback(_debounce(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(loaded) {
      var scheduled;
      return _regeneratorRuntime().wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = Object.entries(loaded).filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                v = _ref3[1];
              return v === SCHEDULED;
            });
            if (scheduled.length) {
              setLoaded(function (l) {
                return _objectSpread(_objectSpread({}, l), Object.fromEntries(scheduled.map(function (_ref4) {
                  var _ref5 = _slicedToArray(_ref4, 1),
                    k = _ref5[0];
                  return [k, LOADING];
                })));
              });
              Object.entries(_groupBy(scheduled.map(function (_ref6) {
                var _ref7 = _slicedToArray(_ref6, 1),
                  q = _ref7[0];
                return fromQuery(q);
              }), function (args) {
                return args.limit ? toQuery(args) : toQuery(_omit.apply(void 0, [args].concat(_toConsumableArray(POLYMORPH))));
              })).forEach(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref8) {
                  var _ref10, q, argList, args, action, res, data;
                  return _regeneratorRuntime().wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _ref10 = _slicedToArray(_ref8, 2), q = _ref10[0], argList = _ref10[1];
                        args = fromQuery(q);
                        action = ACTIONS.find(function (v) {
                          return args[v];
                        }) || "";
                        q = toQuery(_objectSpread(_objectSpread({}, _omit(args, action)), argList.length === 1 ? _pick.apply(void 0, [argList[0]].concat(_toConsumableArray(POLYMORPH))) : {
                          models: Object.fromEntries(Object.entries(_groupBy(argList, "model_type")).map(function (_ref11) {
                            var _ref12 = _slicedToArray(_ref11, 2),
                              type = _ref12[0],
                              models = _ref12[1];
                            return [type, models.map(function (m) {
                              return m.model_id;
                            }).join(",")];
                          }))
                        }));
                        _context.next = 1;
                        return api("".concat(action, "?").concat(q));
                      case 1:
                        res = _context.sent;
                        if (!res.ok) {
                          _context.next = 3;
                          break;
                        }
                        _context.next = 2;
                        return res.json();
                      case 2:
                        data = _context.sent;
                        dispatch({
                          type: action || "set",
                          data: data
                        });
                        _context.next = 4;
                        break;
                      case 3:
                        console.error("Error loading comments", res);
                      case 4:
                        setLoaded(function (l) {
                          return _objectSpread(_objectSpread({}, l), Object.fromEntries(argList.map(function (v) {
                            return [toQuery(v), LOADED];
                          })));
                        });
                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref9.apply(this, arguments);
                };
              }());
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 100), []);
  useEffect(function () {
    load(loaded);
  }, [load, loaded]);
  var dispatch = useCallback(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(action) {
      var id, data, resp, now, comment, likes, _t;
      return _regeneratorRuntime().wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            id = action.id || action.comment && action.comment.id;
            data = action.data || _omit(action, "type");
            _t = action.type;
            _context3.next = _t === "reload" ? 1 : _t === "load" ? 2 : _t === "config" ? 3 : _t === "count" ? 4 : _t === "add" ? 5 : _t === "edit" ? 8 : _t === "delete" ? 9 : _t === "like" ? 10 : 11;
            break;
          case 1:
            reduce({
              type: "reset"
            });
          case 2:
            setLoaded(function (l) {
              return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, toQuery(data), SCHEDULED));
            });
            return _context3.abrupt("continue", 12);
          case 3:
            setConfig(data);
            return _context3.abrupt("continue", 12);
          case 4:
            setCount(function (c) {
              return _objectSpread(_objectSpread({}, c), Object.entries(data).reduce(function (list, _ref14) {
                var _ref15 = _slicedToArray(_ref14, 2),
                  model_type = _ref15[0],
                  ids = _ref15[1];
                Object.entries(ids).forEach(function (_ref16) {
                  var _ref17 = _slicedToArray(_ref16, 2),
                    model_id = _ref17[0],
                    c = _ref17[1];
                  return list[toQuery({
                    model_type: model_type,
                    model_id: model_id
                  })] = c;
                });
                return list;
              }, {}));
            });
            return _context3.abrupt("continue", 12);
          case 5:
            action.comment.user_id = parseInt(user.id);
            resp = api(null, "POST", {
              model: action.comment
            });
            now = dateFormat(new Date(), "yyyy-mm-dd HH:mm:ss");
            action.comment.created = now;
            action.comment.modified = now;
            action.comment.User = {
              firstname: user.firstname,
              image: user.image
            };
            action.comment.cid = cid();
            reduce(action);
            _context3.next = 6;
            return resp;
          case 6:
            _context3.next = 7;
            return _context3.sent.json();
          case 7:
            comment = _context3.sent.Comment;
            reduce(_objectSpread(_objectSpread({}, action), {}, {
              type: "edit",
              comment: _objectSpread(_objectSpread({}, action.comment), comment)
            }));
            return _context3.abrupt("continue", 12);
          case 8:
            reduce(action);
            api(id, "POST", {
              model: action.comment
            });
            return _context3.abrupt("continue", 12);
          case 9:
            reduce(action);
            api(id, "DELETE");
            return _context3.abrupt("continue", 12);
          case 10:
            reduce(action);
            likes = action.comment.AGG_LIKE || {};
            api("".concat(action.type, "/").concat(id, "?pvid=").concat(window.miBaby && window.miBaby.pvid || 0), likes.user ? "DELETE" : "POST");
            return _context3.abrupt("continue", 12);
          case 11:
            reduce(action);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref13.apply(this, arguments);
    };
  }(), [user, reduce]);
  return useMemo(function () {
    return {
      config: config,
      loaded: loaded,
      count: count,
      comments: comments,
      dispatch: dispatch
    };
  }, [config, loaded, count, comments, dispatch]);
};
export default useComments;
//# sourceMappingURL=useComments.js.map